import React from 'react';
import type { DialogContentProps } from '@mui/material';
import { DialogContent } from '@mui/material';

interface CustomDialogContentProps extends DialogContentProps {
  // padding?: string;
  dividers?: boolean;
  children: React.ReactNode;
}

const CustomDialogContent: React.FC<CustomDialogContentProps> = ({
  // padding = '16px',
  dividers = false,
  children,
  ...props
}) => {
  return (
    <DialogContent dividers={dividers} {...props}>
      {children}
    </DialogContent>
  );
};

export default CustomDialogContent;
